<app-single-selection-list-modal
  [id]="'reassign-user-dialog'"
  [title]="'Reassign to another event' | translate"
  [searchPlaceholder]="'Search by name' | translate"
  [sections]="{ columns, contentHeader, disclaimer }"
  [fetchConfig]="{ fetch }"
  [filters]="filters"
  [emptyMessage]="'No events found' | translate"
  [selectButtonText]="'Assign' | translate"
>
  <ng-template #contentHeader>{{ 'Events' | translate }}</ng-template>

  <ng-template #disclaimer>
    {{ 'All times displayed are in {{timezone}}.' | translate: { timezone: data.event.timezone } }}
  </ng-template>

  <ng-template #nameHeader>{{ 'Name' | translate }}</ng-template>
  <ng-template #nameCell let-event>
    <span class="text-ellipsis w-100">{{ event.title }}</span>
    <app-presence-indicator-users
      class="event-users-indicators"
      [users]="event.users"
      [maxLength]="3"
    >
    </app-presence-indicator-users>
  </ng-template>

  <ng-template #timeHeader>{{ 'Time' | translate }}</ng-template>
  <ng-template #timeCell let-event>
    {{ event.start_time | dateUserLocale: DateFormatEnum.SHORTTIME:data.event.timezone }} —
    {{ event.end_time | dateUserLocale: DateFormatEnum.SHORTTIME:data.event.timezone }}
  </ng-template>
</app-single-selection-list-modal>
